<template>
  <div class="text-center">
    <v-dialog v-model="flag" width="850" scrollable>
      <v-card>
        <!-- Title bar -->
        <v-card-title
          class="py-1 px-4 text-truncate dialog-title-border dark-purple-text"
        >
          <div class="d-flex justify-center align-center" style="width: 90%">
            Advanced Filters
          </div>

          <v-spacer></v-spacer>
          <v-icon
            small
            color="#757096"
            @click="
              (flag = false),
                (projectSearch = null),
                (searchMember = null),
                (searchMember2 = null)
            "
            >mdi-close</v-icon
          >
        </v-card-title>

        <v-card-text class="mt-4 custom-dialog">
          <!-- TITLE SEARCH FOR XS-SCREENS-->
          <div v-if="$vuetify.breakpoint.xs">
            <div class="dark-purple-text body-2 font-weight-bold">
              Search By Title
            </div>
            <div class="theme-border mt-2 rounded">
              <v-text-field
                autocomplete="off"
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search Title"
                class="body-2"
                color="#757096"
                hide-details
                solo
                flat
                dense
                v-model="titleSearchQuery"
              >
              </v-text-field>
            </div>
          </div>
          <!-- FILTER BY TASK CATEGORY -->
          <div
            :class="
              getSelectedCompany.role != 'employee' ? 'border-bottom my-2' : ''
            "
          >
            <div
              v-if="getSelectedCompany.role != 'employee'"
              class="dark-purple-text font-weight-bold text-capitalize body-2"
            >
              Task Category
              <!-- <v-icon class="pointer" x-small>mdi-information-outline</v-icon> -->
            </div>
            <div
              :class="
                !$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm ? 'w-50' : ''
              "
              class="d-flex my-2"
            >
              <!-- Show all Tasks Filter -->
              <div
                v-if="getSelectedCompany.role != 'employee'"
                class="pointer pr-2 py-2 caption d-flex anchor-hover pointer"
                @click="changeShowAll('all')"
              >
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getShowAllTasks == 'all'
                      ? 'mdi-checkbox-marked-circle'
                      : 'mdi-checkbox-blank-circle-outline'
                  "
                ></v-icon>
                <span
                  :class="
                    getShowAllTasks == 'all'
                      ? 'success-text font-weight-bold'
                      : 'dark-purple-text'
                  "
                >
                  All Tasks
                </span>
                <v-spacer></v-spacer>
              </div>
              <!-- Show only Me Tasks Filter -->
              <!-- !Employee Case -->
              <div
                v-if="getSelectedCompany.role != 'employee'"
                class="pa-2 caption d-flex anchor-hover pointer"
                @click="changeShowAll('me')"
              >
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getShowAllTasks == 'me'
                      ? 'mdi-checkbox-marked-circle'
                      : 'mdi-checkbox-blank-circle-outline'
                  "
                ></v-icon>
                <span
                  :class="
                    getShowAllTasks == 'me'
                      ? 'success-text font-weight-bold'
                      : 'dark-purple-text'
                  "
                >
                  My Tasks</span
                >
                <v-spacer></v-spacer>
              </div>

              <!-- Employee Case -->
              <div
                v-if="!getSelectedCompany.role"
                class="pa-2 caption d-flex anchor-hover pointer"
                @click="changeShowAll('all')"
              >
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getShowAllTasks == 'all'
                      ? 'mdi-checkbox-marked-circle'
                      : 'mdi-checkbox-blank-circle-outline'
                  "
                ></v-icon>
                <span
                  :class="
                    getShowAllTasks == 'all'
                      ? 'success-text font-weight-bold'
                      : 'dark-purple-text'
                  "
                >
                  My Tasks</span
                >
                <v-spacer></v-spacer>
              </div>

              <!--Show Others Tasks Filter -->
              <div
                v-if="getSelectedCompany.role != 'employee'"
                class="pa-2 caption d-flex anchor-hover pointer"
                @click="changeShowAll('others')"
              >
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getShowAllTasks == 'others'
                      ? 'mdi-checkbox-marked-circle'
                      : 'mdi-checkbox-blank-circle-outline'
                  "
                ></v-icon>
                <span
                  :class="
                    getShowAllTasks == 'others'
                      ? 'success-text font-weight-bold'
                      : 'dark-purple-text'
                  "
                  >Others Tasks</span
                >
                <v-spacer></v-spacer>
              </div>
            </div>
          </div>
          <!-- FILTER BY TASK DESCRIPTION -->
          <v-row class="my-3" no-gutters>
            <!-- Project Filter -->
            <v-col cols="12" sm="4" md="4" class="pr-3 mt-4">
              <div>
                <div class="dark-purple-text mb-1 caption font-weight-bold">
                  Project
                </div>
                <div
                  id="project-dropdown"
                  class="theme-border d-flex align-center border-radius-2 px-2 py-2 pointer"
                  @click="projectSearch = null"
                >
                  <div v-if="getSearchedProject && getSearchedProject.length">
                    <v-chip
                      v-for="pro of getSearchedProject.slice(0, 2)"
                      :key="pro.name"
                      class="pl-2 pr-3"
                      x-small
                      color="blue-chip-color ml-1"
                    >
                      <span
                        class="d-inline-block text-truncate"
                        style="max-width:55px;"
                      >
                        {{ pro.name }}
                      </span>
                    </v-chip>
                    <span
                      class="font-size-10 font-weight-bold dusty-purple-text"
                      v-if="getSearchedProject && getSearchedProject.length > 2"
                    >
                      (+{{
                        getSearchedProject ? getSearchedProject.length - 2 : ""
                      }}
                      more)
                    </span>
                  </div>

                  <span v-else class="dusty-purple-text body-2"
                    >Select Project</span
                  >
                  <v-spacer></v-spacer>
                  <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
                </div>
              </div>
              <!-- Label Filter -->
              <div>
                <div
                  class="dark-purple-text mb-1 mt-2 caption font-weight-bold"
                >
                  Labels
                </div>
                <v-menu :close-on-content-click="false" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="theme-border d-flex align-center border-radius-2 px-2 py-2 pointer"
                      v-bind="attrs"
                      v-on="on"
                      @click="labelSearch = null"
                    >
                      <span v-if="getSearchedLabel">
                        <div
                          v-for="(label, index) of selectedLabel"
                          :key="index"
                        >
                          <v-chip
                            class="pl-2 pr-3"
                            x-small
                            :color="label.hexcode"
                          >
                            <span
                              class="d-inline-block font-weight-bold text-truncate text-capitalize white--text"
                            >
                              {{ label.title }}
                            </span>
                          </v-chip>
                        </div>
                      </span>
                      <span
                        v-if="!getSearchedLabel"
                        class="dusty-purple-text body-2"
                        >Select Label</span
                      >
                      <v-spacer></v-spacer>
                      <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
                    </div>
                  </template>
                  <v-list>
                    <!-- Label List -->
                    <div :class="[{ edited_scrollbar: isMac }]">
                      <!-- Search field -->
                      <div class="search-border rounded ma-2">
                        <v-text-field
                          prepend-inner-icon="mdi-magnify"
                          background-color="white"
                          placeholder="Search..."
                          class="body-2"
                          color="#757096"
                          hide-details
                          solo
                          flat
                          dense
                          autofocus
                          v-model="labelSearch"
                          autocomplete="off"
                          @keydown.enter="labelMenuView = 'create'"
                        >
                        </v-text-field>
                      </div>
                      <v-list
                        class="pointer overflow-scroll"
                        scrollable
                        max-height="260"
                        :class="[{ edited_scrollbar: isMac }]"
                      >
                        <div
                          v-if="!labelSearch"
                          :class="getSearchedLabel == null ? 'bg-selected' : ''"
                          class="d-flex align-center py-1 px-3 body-2 listing-hover list-item-min-height"
                          @click="setLabelFilter(null)"
                        >
                          <span class="pl-5">All Labels</span>
                          <v-spacer></v-spacer>
                          <v-icon
                            color="#1cc283"
                            small
                            v-if="getSearchedLabel == null"
                            >mdi-check-box-outline</v-icon
                          >
                        </div>
                        <div
                          class="my-1 d-flex listing-hover list-item-min-height"
                          :class="
                            findSelectedLabel(item.id) ? 'bg-selected' : ''
                          "
                          v-for="(item, i) in searchedLabels"
                          :key="i"
                          @click="setLabelFilter(item)"
                        >
                          <div
                            class="pointer w-100 px-3 text-capitalize d-flex align-center"
                          >
                            <span
                              class="text-truncate d-inline-block body-2"
                              style="max-width: 150px"
                            >
                              <v-icon
                                class="mr-1"
                                :color="item.hexcode"
                                size="12"
                                >mdi-circle</v-icon
                              >
                              {{ item.title ? item.title : "" }}</span
                            >
                            <v-spacer></v-spacer>
                            <b>
                              <v-icon
                                v-if="findSelectedLabel(item.id)"
                                small
                                color="#1cc283"
                                >mdi-check-box-outline</v-icon
                              ></b
                            >
                          </div>
                        </div>
                        <div
                          v-if="
                            labelSearch &&
                              searchedLabels &&
                              !searchedLabels.length
                          "
                        >
                          <p class="no-results-found my-1">No results found</p>
                        </div>
                      </v-list>
                    </div>
                  </v-list>
                </v-menu>
              </div>
            </v-col>
            <!-- Assigned To -->
            <v-col cols="12" sm="4" md="4" class="pr-3 mt-4">
              <div
                class="dark-purple-text text-capitalize mb-1 caption font-weight-bold"
              >
                Assigned to
              </div>
              <v-menu
                :close-on-content-click="false"
                content-class="white"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <div
                    v-on="on"
                    id="assigned-to-dropdown"
                    class="theme-border d-flex align-center border-radius-2 px-2 py-2 pointer"
                    @click="searchMember = null"
                  >
                    <div
                      v-if="
                        getSearchedAssignedTo && getSearchedAssignedTo.length
                      "
                    >
                      <v-chip
                        class="pl-2 pr-3 ml-1"
                        x-small
                        color="blue-chip-color"
                        v-for="member of getSearchedAssignedTo.slice(0, 2)"
                        :key="member.id"
                      >
                        <span
                          class="d-inline-block text-truncate text-capitalize"
                          style="max-width:55px;"
                        >
                          {{ member.name ? member.name : member.email }}
                        </span>
                      </v-chip>
                      <span
                        class="font-size-10 font-weight-bold dusty-purple-text"
                        v-if="
                          getSearchedAssignedTo &&
                            getSearchedAssignedTo.length > 2
                        "
                      >
                        (+{{
                          getSearchedAssignedTo
                            ? getSearchedAssignedTo.length - 2
                            : ""
                        }}
                        more)
                      </span>
                    </div>

                    <span v-else class="dusty-purple-text body-2"
                      >Select Assignee</span
                    >
                    <v-spacer></v-spacer>
                    <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
                  </div>
                </template>
                <div :class="isMac ? 'edited_scrollbar' : ''">
                  <!-- search field -->
                  <div class="search-border rounded ma-2">
                    <v-text-field
                      autocomplete="off"
                      prepend-inner-icon="mdi-magnify"
                      background-color="white"
                      placeholder="Search..."
                      class="body-2"
                      color="#757096"
                      hide-details
                      dense
                      solo
                      flat
                      v-model="searchMember"
                      autofocus
                    />
                  </div>
                  <v-list max-height="130" class="overflow-scroll" scrollable>
                    <div
                      v-if="!searchMember"
                      class="d-flex list-item-min-height caption listing-hover pointer"
                      @click="
                        selectedAssignedToMembers = [];
                        searchMember = null;
                        $store.commit('setTaskFilter', {
                          assigned_to: [],
                          page: 1,
                        });
                      "
                      :class="
                        getSearchedAssignedTo &&
                        getSearchedAssignedTo.length == 0
                          ? 'bg-selected'
                          : ''
                      "
                    >
                      <profileImage
                        v-show="':username'"
                        inline
                        username="All"
                        :size="23"
                        :userProfile="true"
                        :circular="true"
                        class="ml-3 text-light"
                      >
                      </profileImage>
                      <v-list-item-content
                        @click="assignedToDropdown = false"
                        class="ml-2"
                      >
                        All Members
                      </v-list-item-content>
                      <v-icon
                        small
                        color="#1cc283"
                        class="mr-3"
                        v-text="
                          getSearchedAssignedTo &&
                          getSearchedAssignedTo.length == 0
                            ? 'mdi-check-box-outline'
                            : ''
                        "
                      ></v-icon>
                    </div>
                    <div
                      class="d-flex pointer list-item-min-height caption listing-hover"
                      v-for="member in filteredMembers"
                      :key="member.id"
                      @click="
                        searchMember = null;
                        getSearchedAssignedTo
                          ? getSearchedAssignedTo.find((item) => {
                              return item.id == member.id;
                            })
                            ? unSelectAssignedToMember(member)
                            : selectAssignedToMember(member)
                          : selectAssignedToMember(member);
                        assignedToDropdown = false;
                      "
                      :class="
                        getSearchedAssignedTo
                          ? getSearchedAssignedTo.find((item) => {
                              return item.id == member.id;
                            })
                            ? 'bg-selected'
                            : ''
                          : ''
                      "
                    >
                      <profileImage
                        v-show="member.image ? ':src' : ':username'"
                        :src="member.image"
                        inline
                        :username="member.name ? member.name : member.email"
                        :size="23"
                        :userProfile="true"
                        :circular="true"
                        class="ml-3 text-light"
                      >
                      </profileImage>

                      <v-list-item-content
                        style="max-width: 160px"
                        class="d-inline-block text-truncate ml-2"
                        :class="member.name ? 'text-capitalize' : ''"
                      >
                        {{
                          member.name ? member.name : member.email
                        }}</v-list-item-content
                      >
                      <v-spacer></v-spacer>
                      <v-icon
                        small
                        color="#1cc283"
                        class="mr-3"
                        v-text="
                          getSearchedAssignedTo
                            ? getSearchedAssignedTo.find((item) => {
                                return item.id == member.id;
                              })
                              ? 'mdi-check-box-outline'
                              : ''
                            : ''
                        "
                      ></v-icon>
                    </div>

                    <div v-if="searchMember && !filteredMembers.length">
                      <p class="no-results-found my-1">No results found</p>
                    </div>
                  </v-list>
                </div>
              </v-menu>
            </v-col>
            <!-- Assigned By -->
            <v-col md="4" cols="12" sm="4" class="pt-1 pr-3 mt-3">
              <div class="dark-purple-text mb-1 caption font-weight-bold">
                Assigned By
              </div>
              <!-- Assigned By Dropdown -->
              <v-menu
                :close-on-content-click="false"
                content-class="white"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <div
                    v-on="on"
                    id="assigned-by-dropdown"
                    class="theme-border d-flex align-center border-radius-2 px-2 py-2 pointer"
                    @click="searchMember2 = null"
                  >
                    <div
                      v-if="
                        getSearchedAssignedBy && getSearchedAssignedBy.length
                      "
                    >
                      <v-chip
                        class="pl-2 pr-3 ml-1"
                        x-small
                        color="blue-chip-color"
                        v-for="member of getSearchedAssignedBy.slice(0, 2)"
                        :key="member.id"
                      >
                        <span
                          class="d-inline-block text-truncate text-capitalize"
                          style="max-width:55px;"
                        >
                          {{ member.name ? member.name : member.email }}
                        </span>
                      </v-chip>
                      <span
                        class="font-size-10 font-weight-bold dusty-purple-text"
                        v-if="
                          getSearchedAssignedBy &&
                            getSearchedAssignedBy.length > 2
                        "
                      >
                        (+{{
                          getSearchedAssignedBy
                            ? getSearchedAssignedBy.length - 2
                            : ""
                        }}
                        more)
                      </span>
                    </div>

                    <span class="dusty-purple-text body-2" v-else
                      >Select Assigner</span
                    >
                    <v-spacer></v-spacer>
                    <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
                  </div>
                </template>
                <div :class="isMac ? 'edited_scrollbar' : ''">
                  <!-- search field -->
                  <div class="search-border rounded ma-2">
                    <v-text-field
                      autocomplete="off"
                      prepend-inner-icon="mdi-magnify"
                      background-color="white"
                      placeholder="Search..."
                      class="body-2"
                      color="#757096"
                      hide-details
                      solo
                      dense
                      flat
                      v-model="searchMember2"
                      autofocus
                    />
                  </div>
                  <v-list max-height="130" class="overflow-scroll" scrollable>
                    <div
                      v-if="!searchMember2"
                      class="d-flex list-item-min-height caption listing-hover pointer"
                      @click="
                        searchMember2 = null;
                        selectedAssignedByMembers = [];
                        $store.commit('setTaskFilter', {
                          assigned_by: [],
                          page: 1,
                        });
                      "
                      :class="
                        getSearchedAssignedBy &&
                        getSearchedAssignedBy.length == 0
                          ? 'bg-selected'
                          : ''
                      "
                    >
                      <profileImage
                        v-show="':username'"
                        inline
                        username="All"
                        :size="23"
                        :userProfile="true"
                        :circular="true"
                        class="ml-3 text-light"
                      >
                      </profileImage>
                      <v-list-item-content
                        @click="assignedByDropdown = false"
                        class="ml-2"
                      >
                        All Members
                      </v-list-item-content>
                      <v-icon
                        small
                        color="#1cc283"
                        class="mr-3"
                        v-text="
                          getSearchedAssignedBy &&
                          getSearchedAssignedBy.length == 0
                            ? 'mdi-check-box-outline'
                            : ''
                        "
                      ></v-icon>
                    </div>
                    <div
                      class="d-flex list-item-min-height caption listing-hover pointer"
                      v-for="member in filteredMembers2"
                      :key="member.id"
                      @click="
                        searchMember2 = null;
                        getSearchedAssignedBy
                          ? getSearchedAssignedBy.find((item) => {
                              return item.id == member.id;
                            })
                            ? unSelectAssignedByMember(member)
                            : selectAssignedByMember(member)
                          : selectAssignedByMember(member);
                        assignedByDropdown = false;
                      "
                      :class="
                        getSearchedAssignedBy
                          ? getSearchedAssignedBy.find((item) => {
                              return item.id == member.id;
                            })
                            ? 'bg-selected'
                            : ''
                          : ''
                      "
                    >
                      <profileImage
                        v-show="member.image ? ':src' : ':username'"
                        :src="member.image"
                        inline
                        :username="member.name ? member.name : member.email"
                        :size="23"
                        :userProfile="true"
                        :circular="true"
                        class="ml-3 text-light"
                      >
                      </profileImage>

                      <v-list-item-content
                        style="max-width: 160px"
                        class="d-inline-block text-truncate ml-2"
                        :class="member.name ? 'text-capitalize' : ''"
                      >
                        {{
                          member.name ? member.name : member.email
                        }}</v-list-item-content
                      >
                      <v-spacer></v-spacer>
                      <v-icon
                        small
                        color="#1cc283"
                        class="mr-3"
                        v-text="
                          getSearchedAssignedBy
                            ? getSearchedAssignedBy.find((item) => {
                                return item.id == member.id;
                              })
                              ? 'mdi-check-box-outline'
                              : ''
                            : ''
                        "
                      ></v-icon>
                    </div>
                    <div v-if="searchMember2 && !filteredMembers2.length">
                      <p class="no-results-found my-1">No results found</p>
                    </div>
                  </v-list>
                </div>
              </v-menu>
            </v-col>
            <!-- Task Status -->
            <v-col sm="12" md="8">
              <div
                class="mr-16 mt-3"
                :class="!$vuetify.breakpoint.xs ? 'd-flex align-center' : ''"
              >
                <span class="dark-purple-text caption font-weight-bold mr-3"
                  >Status</span
                >
                <div
                  v-for="status in statusList"
                  :key="status.text"
                  class="status-list-min-height caption anchor-hover pointer d-flex align-center"
                  @click="
                    status.text == 'Archive'
                      ? $store.commit('setTaskFilter', {
                          status: status.value,
                          archived: true,
                        })
                      : $store.commit('setTaskFilter', {
                          archived: false,
                          status: status.value,
                          page: 1,
                        })
                  "
                >
                  <div class="d-flex align-center">
                    <v-icon
                      small
                      color="#1cc283"
                      class="pr-2"
                      v-text="
                        getSearchedStatus
                          ? getSearchedStatus == status.value
                            ? 'mdi-checkbox-marked-circle'
                            : 'mdi-checkbox-blank-circle-outline'
                          : ''
                      "
                    ></v-icon>
                    <span
                      :class="
                        getSearchedStatus
                          ? getSearchedStatus == status.value
                            ? 'success-text font-weight-bold'
                            : 'dark-purple-text'
                          : ''
                      "
                      class="text-capitalize anchor-hover mr-3"
                    >
                      {{ status.text }}
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
            <!-- Sort by Flagged & Filter by Recurring -->
            <v-col sm="12" md="4">
              <!-- <div class="text-capitalize dusty-purple-text">Sort By</div> -->
              <div
                :class="!$vuetify.breakpoint.xs ? '' : ''"
                class="d-flex w-100"
              >
                <!-- Recurring -->
                <div
                  :class="!$vuetify.breakpoint.xs ? 'mr-4 ' : ''"
                  class="d-flex align-center mt-4"
                  @click="
                    getRecurringTasks
                      ? $store.commit('setTaskFilter', {
                          recurring: false,
                        })
                      : $store.commit('setTaskFilter', {
                          recurring: true,
                        })
                  "
                >
                  <v-icon
                    v-if="getRecurringTasks"
                    color="primary"
                    class="mr-2 pointer"
                    small
                    >mdi-check-box-outline</v-icon
                  >
                  <v-icon v-else color="primary" class="mr-2 pointer" small
                    >mdi-checkbox-blank-outline</v-icon
                  >
                  <span class="body-2 dark-purple-text pointer">
                    Recurring
                  </span>
                </div>
                <!-- Flagged -->
                <div
                  @click="
                    getFlaggedTasks && getFlaggedTasks == 'Flagged'
                      ? ($store.commit('setTaskFilter', {
                          sort: {
                            order_by: '',
                            column_name: '',
                          },
                        }),
                        $store.commit('setFlagged', {
                          flagged: 'All',
                        }))
                      : ($store.commit('setTaskFilter', {
                          sort: {
                            order_by: 'desc',
                            column_name: 'is_flagged',
                          },
                        }),
                        $store.commit('setFlagged', {
                          flagged: 'Flagged',
                        }))
                  "
                  class="d-flex align-center mr-4 mt-4"
                >
                  <v-icon
                    small
                    color="primary"
                    class="mr-2 pointer"
                    v-if="getFlaggedTasks && getFlaggedTasks == 'Flagged'"
                    :class="$vuetify.breakpoint.xs ? 'ml-1' : ''"
                    >mdi-check-box-outline</v-icon
                  >
                  <v-icon
                    small
                    v-else
                    :class="$vuetify.breakpoint.xs ? 'ml-1' : ''"
                    color="primary"
                    class="mr-2 pointer"
                    >mdi-checkbox-blank-outline</v-icon
                  >
                  <span class="body-2 text-center dark-purple-text pointer">
                    Flagged
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>
          <div class="border-bottom"></div>
          <!-- FILTER BY TASK STATUS, TIME  -->
          <v-row class="mt-4" no-gutters>
            <!-- Filter by time -->
            <v-col cols="12" md="12">
              <div
                class="text-capitalize d-flex align-center dark-purple-text font-weight-bold body-2"
              >
                date range
              </div>
              <div :class="[isMac ? 'edited_scrollbar' : '']">
                <v-list class="d-flex">
                  <div
                    v-for="list of dropdownList.slice(0, 6)"
                    :key="list.text"
                    class="status-list-min-height  caption anchor-hover d-flex align-center pointer"
                    @click="$store.commit('setTaskDateFilter', list.text)"
                  >
                    <div class="d-flex align-center">
                      <v-icon small color="#1cc283" class="pr-2">
                        {{
                          getTaskDateFilter == list.text
                            ? "mdi-checkbox-marked-circle"
                            : "mdi-checkbox-blank-circle-outline"
                        }}</v-icon
                      >
                      <span
                        class="mr-3"
                        :class="
                          getTaskDateFilter == list.text
                            ? 'success-text font-weight-bold'
                            : 'dark-purple-text'
                        "
                        >{{ list.text }}</span
                      >
                    </div>
                  </div>
                </v-list>
                <v-list class="d-flex mt-n4">
                  <div
                    v-for="list of dropdownList.slice(6, 8)"
                    :key="list.text"
                    class="status-list-min-height  caption anchor-hover d-flex align-center pointer"
                    @click="$store.commit('setTaskDateFilter', list.text)"
                  >
                    <div class="d-flex align-center">
                      <v-icon small color="#1cc283" class="pr-2">
                        {{
                          getTaskDateFilter == list.text
                            ? "mdi-checkbox-marked-circle"
                            : "mdi-checkbox-blank-circle-outline"
                        }}</v-icon
                      >
                      <span
                        class="mr-3"
                        :class="
                          getTaskDateFilter == list.text
                            ? 'success-text font-weight-bold'
                            : 'dark-purple-text'
                        "
                        >{{ list.text }}</span
                      >
                    </div>
                  </div>
                </v-list>

                <div
                  v-if="getTaskDateFilter == 'Custom range'"
                  style="width:80%"
                  class="d-flex justify-center date-picker rounded mt-2 pb-2"
                >
                  <div class="theme-border">
                    <v-date-picker v-model="dateRange" range></v-date-picker>
                  </div>
                </div>
              </div>
            </v-col>
            <!-- <div
              v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm"
              style="height: 200px"
              class="border-right mr-7 ml-n6"
            ></div> -->
            <!-- <div
              v-if="
                !$vuetify.breakpoint.xs &&
                !$vuetify.breakpoint.sm &&
                getView == 'kanban'
              "
              style="height: 200px"
              class="border-right mr-5 ml-n5"
            ></div> -->
          </v-row>
          <!-- SORT BY -->
          <!-- <div class="border-bottom my-4"></div> -->
          <v-row no-gutters>
            <!-- <v-col cols="12">
              <div
                class="dark-purple-text font-weight-bold text-capitalize body-2"
              >
                Sort By
              </div>
            </v-col> -->
            <!-- ORDER BY NO. OF COMMENTS -->
            <v-col
              v-if="getView == 'kanban'"
              cols="6"
              :md="getView == 'list' ? '3' : '2'"
            >
              <div
                class="text-capitalize d-flex pt-1 mt-3 align-center dark-purple-text font-weight-bold caption"
              >
                Comments
              </div>
              <div
                @click="sortByComment('asc')"
                class="caption dark-purple-text d-flex pt-1 align-center caption anchor-hover pointer"
              >
                <v-icon color="primary" class="mr-2" small>
                  {{
                    selected == "asc"
                      ? "mdi-checkbox-marked-circle"
                      : "mdi-checkbox-blank-circle-outline"
                  }}
                </v-icon>
                <span
                  :class="
                    selected == 'asc'
                      ? 'success-text font-weight-bold'
                      : 'dark-purple-text'
                  "
                  >Ascending</span
                >
              </div>
              <div
                @click="sortByComment('desc')"
                class="body-2 d-flex pt-1 align-center caption anchor-hover pointer"
              >
                <v-icon color="primary" class="mr-2" small>
                  {{
                    selected == "desc"
                      ? "mdi-checkbox-marked-circle"
                      : "mdi-checkbox-blank-circle-outline"
                  }}
                </v-icon>
                <span
                  :class="
                    selected == 'desc'
                      ? 'success-text font-weight-bold'
                      : 'dark-purple-text'
                  "
                  >Descending</span
                >
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="border-top">
          <div class="d-flex align-center w-100">
            <v-btn
              depressed
              small
              color="#edebf9"
              class="text-capitalize"
              @click="resetTaskFilters"
            >
              <v-icon color="#2a206a" small>mdi-restore</v-icon>
              <span class="body-2 mx-1 dark-purple-text">Reset Filters</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="#edebf9"
              class="text-capitalize theme-filled-btn"
              @click="fetchCall()"
            >
              <span class="body-2 mx-1">Apply</span>
            </v-btn>
          </div>
        </v-card-actions>

        <!-- DROPDOWNS -->
        <!-- Project Dropdown -->
        <v-menu
          :close-on-content-click="false"
          activator="#project-dropdown"
          offset-y
        >
          <div
            class="py-0 px-2 py-2 white"
            :class="isMac ? 'edited_scrollbar' : ''"
          >
            <!-- search field -->
            <div class="search-border py-0 rounded">
              <v-text-field
                autocomplete="off"
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search..."
                class="body-2"
                color="#757096"
                hide-details
                solo
                flat
                dense
                v-model="projectSearch"
                autofocus
                @click="projectSearch = null"
              >
              </v-text-field>
            </div>
            <v-list max-height="130" class="pointer overflow-scroll" scrollable>
              <div
                v-if="!projectSearch"
                class="d-flex list-item-min-height caption listing-hover pointer"
                @click="
                  $store.commit('setTaskFilter', {
                    project_id: [],
                    page: 1,
                  });
                  selectedProjects = [];
                  projectSearch = null;
                "
                :class="
                  getSearchedProject && getSearchedProject.length == 0
                    ? 'bg-selected'
                    : ''
                "
              >
                <profileImage
                  v-show="':username'"
                  inline
                  username="All"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content class="ml-2">
                  All Projects
                </v-list-item-content>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getSearchedProject && getSearchedProject.length == 0
                      ? 'mdi-check-box-outline'
                      : ''
                  "
                ></v-icon>
              </div>
              <div
                v-for="project in projectsList"
                :key="project.id"
                class="list-item-min-height caption listing-hover d-flex pointer"
                @click="
                  projectSearch = null;
                  getSearchedProject
                    ? getSearchedProject.find((item) => {
                        return item.id == project.id;
                      })
                      ? unSelectProject(project)
                      : selectProject(project)
                    : selectProject(project);
                "
                :class="
                  getSearchedProject
                    ? getSearchedProject.find((item) => {
                        return item.id == project.id;
                      })
                      ? 'bg-selected'
                      : ''
                    : ''
                "
              >
                <profileImage
                  inline
                  :username="project.name"
                  :size="23"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content
                  ><span
                    style="width: 30px"
                    class="d-inline-block text-truncate ml-2 text-capitalize"
                  >
                    {{ project.name }}
                  </span>
                </v-list-item-content>
                <v-spacer></v-spacer>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getSearchedProject
                      ? getSearchedProject.find((item) => {
                          return item.id == project.id;
                        })
                        ? 'mdi-check-box-outline'
                        : ''
                      : ''
                  "
                ></v-icon>
              </div>
              <div v-if="projectSearch && !projectsList.length">
                <p class="no-results-found my-1">No results found</p>
              </div>
            </v-list>
          </div>
        </v-menu>
      </v-card>
    </v-dialog>
    <SnackbarNew
      :snackbar.sync="snackbar"
      :snackbarError="snackbarError"
      :snackbarMessage="snackbarMessage"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import { projectsCRUD } from "@/mixins/projectsCRUD";
import { memberSearchMixin } from "@/mixins/memberSearchMixin";
import _ from "lodash";
import { snackbarMixin } from "@/mixins/snackbarMixin";

export default {
  props: ["drawer"],
  mixins: [projectsCRUD, memberSearchMixin, snackbarMixin],
  components: {
    profileImage: () => import("@/components/Includes/ProfileImage"),
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
  },
  data() {
    return {
      dateRange: this.getCustomDateRange,
      labelSearch: null,
      selectedLabel: [],
      flag: false,
      projectSearch: null,
      searchMember: null,
      selectedProjects: [],
      selectedAssignedByMembers: [],
      selectedAssignedToMembers: [],
      searchMember2: null,
      selected: "",
      titleSearchQuery: null,
      projectsAccordian: true,
      assignedToDropdown: false,
      assignedByDropdown: false,
      commentDropdown: false,
      statusList: [
        { text: "all", value: "all" },
        { text: "pending", value: "pending" },
        { text: "completed", value: "completed" },
        { text: "expired", value: "completed_overdue" },
        { text: "Archive", value: "archived" },
      ],
      flaggedList: [{ text: "All" }, { text: "Flagged" }],
      recurringList: [{ text: "All" }, { text: "Recurring" }],
      taskList: [{ text: "All" }, { text: "Archive" }],
      dropdownList: [
        { text: "Today" },
        { text: "Yesterday" },
        { text: "Last 7 days" },
        { text: "Last 30 days" },
        { text: "This month" },
        { text: "Last month" },
        { text: "All time" },
        { text: "Custom range" },
      ],
    };
  },
  watch: {
    drawer(value) {
      if (value) this.flag = true;
    },
    flag(value) {
      if (!value) this.$emit("update:drawer", false);
    },

    titleSearchQuery: {
      handler: _.debounce(function() {
        this.searchTitle();
      }, 1000),
      deep: true,
    },

    getSearchedTitle(value) {
      if (!value) {
        this.titleSearchQuery = value;
      }
    },
  },
  computed: {
    ...mapGetters([
      "getLoggedInUser",
      "getAssigneesKanban",
      "getSearchedProject",
      "getProject",
      "getSelectedCompany",
      "getShowAllTasks",
      "getView",
      "getSearchedAssignedTo",
      "getSearchedAssignedBy",
      "getSearchedStatus",
      "getTaskDateFilter",
      "getFlaggedTasks",
      "getRecurringTasks",
      "getTaskStatus",
      "getArchivedTasks",
      "getTaskFilters",
      "getAllLabels",
      "getSearchedLabel",
      "getCustomDateRange",
    ]),
    searchedLabels() {
      return this.getAllLabels && this.labelSearch
        ? this.getAllLabels.filter((item) => {
            return item.title
              ? item.title
                  .toLowerCase()
                  .includes(this.labelSearch.toLowerCase())
              : false;
          })
        : this.getAllLabels;
    },
  },
  mounted() {
    eventBus.$on("deleteSelectedSearchedProject", (project_id) => {
      this.selectedProjects = this.selectedProjects.filter((item) => {
        return item != project_id;
      });
    });
    eventBus.$on("customDateRange", (payload) => {
      this.dateRange = payload;
    });
    eventBus.$on("setResetFilter", () => {
      this.selectedProjects = [];
      this.selectedAssignedByMembers = [];
      this.selectedAssignedToMembers = [];
    });
  },
  beforeDestroy() {
    eventBus.$off("customDateRange");
    eventBus.$off("setResetFilter");
  },
  methods: {
    setLabelFilter(label) {
      if(label !=null){
         let labelExistIndex = this.selectedLabel.findIndex((labelItem) => {
        if (labelItem.id == label.id) {
          return labelItem;
        }
      });
      if (labelExistIndex > -1) {
        this.selectedLabel.splice(labelExistIndex, 1);
      } else {
        this.selectedLabel.push(label);
      }
      this.$store.commit("setTaskFilter", {
        label: this.selectedLabel,
      });
      }
      else{
        this.selectedLabel = []
        this.$store.commit("setTaskFilter", {
        label: null,
      });
      }
     
    },
    resetTaskFilters() {
      this.titleSearchQuery = null;
      this.selectedAssignedByMembers = [];
      this.selectedAssignedToMembers = [];
      this.selectedProjects = [];
         this.selectedLabel = []
      //this.$store.commit("resetTaskFilters");
      this.$store.dispatch("updateTaskCategory");
      this.$store.commit("setFlagged", {
        flagged: "All",
      });
      this.$store.commit("setTaskFilter", {
        sort: {
          order_by: "",
          column_name: "",
        },
      });
      this.selected = null;
      this.projectSearch = null;
      this.$store.commit("setTaskFilter", {
        sort: {
          order_by: null,
          column_name: null,
        },
      });
      if (this.getView == "kanban") {
        this.$store.dispatch("fetchKanbanTasks", "pending");
        this.$store.dispatch("fetchKanbanTasks", "completed");
        this.$store.dispatch("fetchKanbanTasks", "active");
      } else if (this.getView == "list") {
        this.$store.dispatch("fetchTasks");
      }
    },
    unSelectProject(project) {
      if (this.selectedProjects && this.selectedProjects.length == 1) {
        this.selectedProjects = [];
      } else {
        this.selectedProjects = this.selectedProjects.filter((item) => {
          return item != project.id;
        });
      }
      this.$store.commit("setTaskFilter", {
        project_id: this.selectedProjects,
        page: 1,
      });
    },
    selectProject(project) {
      this.selectedProjects.push(project.id);
      this.$store.commit("setTaskFilter", {
        project_id: this.selectedProjects,
        page: 1,
      });
    },
    unSelectAssignedByMember(member) {
      if (
        this.selectedAssignedByMembers &&
        this.selectedAssignedByMembers.length == 1
      ) {
        this.selectedAssignedByMembers = [];
      } else {
        this.selectedAssignedByMembers = this.selectedAssignedByMembers.filter(
          (item) => {
            return item.id != member.id;
          }
        );
      }
      this.$store.commit("setTaskFilter", {
        assigned_by: this.selectedAssignedByMembers,
        page: 1,
      });
    },
    selectAssignedByMember(member) {
      this.selectedAssignedByMembers.push(member);
      this.$store.commit("setTaskFilter", {
        assigned_by: this.selectedAssignedByMembers,
        page: 1,
      });
    },
    unSelectAssignedToMember(member) {
      if (
        this.selectedAssignedToMembers &&
        this.selectedAssignedToMembers.length == 1
      ) {
        this.selectedAssignedToMembers = [];
      } else {
        this.selectedAssignedToMembers = this.selectedAssignedToMembers.filter(
          (item) => {
            return item.id != member.id;
          }
        );
      }
      this.$store.commit("setTaskFilter", {
        assigned_to: this.selectedAssignedToMembers,
        page: 1,
      });
    },
    selectAssignedToMember(member) {
      this.selectedAssignedToMembers.push(member);
      this.$store.commit("setTaskFilter", {
        assigned_to: this.selectedAssignedToMembers,
        page: 1,
      });
    },
    resetFilters() {
      if (this.$route.path != "/task") this.$router.push({ name: "task" });
      this.titleSearchQuery = null;
    },
    searchTitle() {
      if (this.getView == "list") {
        this.$store.commit("setTaskFilter", { title: this.titleSearchQuery });
      }
    },
    changeShowAll(option) {
      if (option == "me") {
        this.selectedAssignedByMembers = [];
        this.$store.commit("setTaskFilter", {
          show_tasks: option,
          assigned_by: [],
          page: 1,
        });
      } else {
        this.$store.commit("setTaskFilter", {
          show_tasks: option,
          page: 1,
        });
      }

      // this.fetchCall();
    },
    fetchCall() {
      if (this.dateRange && this.dateRange.length) {
        if (this.dateRange[0] > this.dateRange[1]) {
          var temp = this.dateRange[0];
          this.dateRange[0] = this.dateRange[1];
          this.dateRange[1] = temp;
        }
        this.$store.commit("setCustomDateRange", this.dateRange);
        this.$store.commit("setTaskFilter", {
          start_date: this.dateRange[0],
          end_date: this.dateRange[1],
          page: 1,
        });
        if (this.dateRange.length == 2) this.fetchingTasks();
        else this.openSnackbar(true, "Please select the valid range!");
      } else this.fetchingTasks();
    },
    fetchingTasks() {
      if (this.getView == "kanban") {
        this.$store.dispatch("fetchKanbanTasks", "pending");
        this.$store.dispatch("fetchKanbanTasks", "completed");
        this.$store.dispatch("fetchKanbanTasks", "active");
      } else if (this.getView == "list") {
        this.$store.dispatch("fetchTasks");
      }
      this.flag = false;
    },
    sortByComment(filter) {
      this.selected = filter;
      this.$store.commit("setTaskFilter", {
        sort: {
          order_by: filter,
          column_name: "comment_count",
        },
      });
      // this.fetchCall();
    },
    sortByFunction(column, order) {
      this.$store.commit("setFlagged", {
        flagged: "All",
      });
      this.$store.commit("setTaskFilter", {
        sort: {
          order_by: order,
          column_name: column,
        },
      });
      // this.fetchCall();
    },
    findSelectedLabel(labelId) {
      if (this.getSearchedLabel) {
        let labelSelectd = this.getSearchedLabel.find((label) => {
          return label == labelId;
        });

        if (labelSelectd) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
};
</script>

<style scoped>
.border-bottom-dashed {
  border-bottom: 1px dashed #dcd8f3;
}
.ext-margin {
  margin-top: 48px !important;
}
.non-ext-margin {
  margin-top: 46px !important;
}
.panel-header-font {
  font-size: 13.5px !important;
}
.anchor-hover:hover {
  font-weight: bold;
  /* color: #1cc283 !important; */
}
.border-right {
  border-right: 1px dashed #dcd8f3;
}
.w-50 {
  width: 50% !important;
}
</style>
<style>
.datetime-picker input[data-v-a46a390c] {
  width: 150px !important;
  height: 38px !important;
}
.date-picker .v-picker__title {
  display: none !important;
}
.date-picker .v-date-picker-table--date .v-btn {
  height: 24px !important;
  width: 24px !important;
}
.date-picker .v-date-picker-table {
  height: 190px !important;
}
</style>
